import React, { useState, useEffect } from "react";
import "../pages/styles.css";
import Header from "../components/header";
import img1 from "../assets/employee_certificates/1.png";
import img2 from "../assets/employee_certificates/2.png";
import img3 from "../assets/employee_certificates/3.png";

import img4 from "../assets/employee_certificates/4.png";
import img5 from "../assets/employee_certificates/6.png";
import img6 from "../assets/employee_certificates/6.png";
import {
  LazyLoadComponent,
  LazyLoadImage,
} from "react-lazy-load-image-component";
import img7 from "../assets/promotionmaker/6.webp";
import img8 from "../assets/promotionmaker/7.webp";
import img9 from "../assets/promotionmaker/8.webp";

import Button from "@mui/material/Button";
import axios from "axios";
import Footer from "../components/Footer";

import { useSelector, useDispatch } from "react-redux";
import { loginModal } from "../Redux/authAction";

import { NavLink } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import apiConfig from '../config/api.js';

const Catelog = () => {
  const [data, setData] = useState([]);
  const [img, setImg] = useState(`${img1}`);
  const isLang = useSelector((state) => state.authReducer.lang);

  //------------------

  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  const dispatch = useDispatch();

  const handleOpen = () => {
    dispatch(loginModal(true));
    setOpenModel(false);
  };
  const handelOpenModel = () => {
    dispatch(loginModal(false));
    setOpenModel(true);
  };
  const handleClose = () => {
    dispatch(loginModal(false));
    dispatch(loginModal(false));
  };
  const handleCloseModel = () => setOpenModel(false);
  const [openModel, setOpenModel] = useState(false);

  // Function
  const [menu, setMenu] = useState("");
  const handleMouseOver = (type) => {
    setMenu(type);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiConfig.API_URL}/aapi/tempbycat.php?title=Employee Certificates`
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  console.log("data-=-=-=-", data);
  return (
    <>
      <Header menu={menu} setMenu={setMenu} />
      <div onMouseOver={() => handleMouseOver("")} className="text-black"></div>
      <div className="pt-20 bg-purple-500">
      <div className="grid grid-cols-2 p-5">
  <div
    className="p-10 ml-5 text-white text-[16px]"
    style={{
      textAlign: isLang === 'eng' ? 'left' : 'right',
      direction: isLang === 'eng' ? 'ltr' : 'rtl',
    }}
  >
    {isLang === 'eng' ? (
      <>
        <p className="text-4xl font-semibold">Professional Certificate Maker</p>
        <p style={{ fontSize: "16px" }}>
          Craft elegant and professional certificates to commemorate your achievements with Maker4U's Certificate Maker. From employee recognition to academic accomplishments, our user-friendly platform empowers you to design custom certificates that stand out. Elevate your professional image and celebrate success in style with Maker4U's Certificate Maker.
          <br /> <br />
          Create memorable certificates effortlessly and impress your audience with our intuitive design tools. These innovative tools are designed to help you honor and celebrate the achievements of your team members in a meaningful and professional manner.
        </p>
      </>
    ) : (
      <>
        <p className="text-4xl font-semibold">صانع الشهادات الاحترافي</p>
        <p style={{ fontSize: "16px" }}>
          اصنع شهادات أنيقة واحترافية للاحتفال بإنجازاتك باستخدام أداة صانع الشهادات من Maker4U. من تقدير الموظفين إلى الإنجازات الأكاديمية، تتيح لك منصتنا سهلة الاستخدام تصميم شهادات مخصصة بارزة. ارتقِ بصورتك المهنية واحتفل بالنجاح بأناقة مع أداة صانع الشهادات من Maker4U.
          <br /> <br />
          أنشئ شهادات لا تُنسى بسهولة وأبهر جمهورك باستخدام أدوات التصميم البديهية لدينا. تم تصميم هذه الأداة المبتكرة لمساعدتك على تكريم إنجازات أعضاء فريقك والاحتفال بها بطريقة هادفة واحترافية.
        </p>
      </>
    )}
  </div>

  <div>
    <LazyLoadImage src={`${img1}`} className="w-full h-full px-4" />
  </div>
</div>

      </div>
      <p className=" text-[28px] text-center font-[500] mt-10">
  {isLang === 'eng' ? 'Create Employment Certificate' : 'إنشاء شهادة توظيف'}
</p>

<div
  className="flex justify-center"
  style={{ marginTop: "20px", marginBottom: "20px" }}
>
  <div
    className="text-center"
    style={{ maxWidth: "840px", textAlign: isLang === 'eng' ? 'left' : 'right', direction: isLang === 'eng' ? 'ltr' : 'rtl' }}
  >
    <p
      style={{
        fontFamily: "poppins",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "1.375rem",
        letterSpacing: ".024375rem",
      }}
    >
      {isLang === 'eng' ? (
        "In recognition of your employees' dedication and hard work, Maker4U is proud to introduce our Employment Certificate Maker. This innovative tool is designed to help you honor and celebrate the achievements of your team members in a meaningful and professional manner."
      ) : (
        "تقديرًا لتفاني موظفيك وعملهم الجاد، تفخر Maker4U بتقديم أداة إنشاء شهادات التوظيف الخاصة بنا. تم تصميم هذه الأداة المبتكرة لمساعدتك على تكريم إنجازات أعضاء فريقك والاحتفال بها بطريقة هادفة ومهنية."
      )}
    </p>
  </div>
</div>

      <div
        className="card-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {data.map((item) => (

          <NavLink
            to={`/ResumeMaker/temp/${item?.id}`}
            className="hover:no-underline"
          >
            <Card sx={{ maxWidth: 225 }}>
              <CardMedia
                component="img"
                alt="green iguana"
                height="120"
                image={`${apiConfig.API_URL}/aapi/templetes/${item.imagepath}`}
              />
              <CardContent
                className=" m-0 h-8 pb-3 text-left font-medium"
                style={{ fontFamily: "poppins" }}
              >
                <Typography gutterBottom variant="h8" component="div">
                  {item.title}
                </Typography>
              </CardContent>
            </Card>
          </NavLink>
        ))}
      </div>

      <NavLink
          to="/resumeMaker/temp/Employee Certificates"
          >
      <Button
        variant="contained"
        onClick={handleOpen}
        style={{
          margin: "auto",
          display: "block",
          borderRadius: "20px",
          width: "180px",
          backgroundColor:
            "#882ED8",
        }}
      >
        SHOW MORE
      </Button>
      </NavLink>
      <p className="my-16 text-[28px] text-center font-[500]">
  {isLang === 'eng'
    ? 'Craft Professional Certificates in Minutes with Maker4U'
    : 'أنشئ شهادات احترافية في دقائق باستخدام Maker4U'}
</p>

<div
  className="imageGrid"
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  <div>
    <LazyLoadImage src={`${img5}`} />
  </div>
  <div>
    <div onClick={() => setImg(`${img5}`)}>
      <LazyLoadImage src={`${img5}`} />
    </div>
    <div onClick={() => setImg(`${img6}`)}>
      <LazyLoadImage src={`${img6}`} />
    </div>
    <div onClick={() => setImg(`${img4}`)}>
      <LazyLoadImage src={`${img4}`} />
    </div>
  </div>
</div>

<div
  className="catelogTextContainer"
  style={{
    textAlign: isLang === 'eng' ? 'left' : 'right',
    direction: isLang === 'eng' ? 'ltr' : 'rtl',
  }}
>
  <div className="catelogText">
    <p style={{ fontSize: "16px" }}>
      {isLang === 'eng' ? (
        <>
          With our Employment Certificate Maker, you can easily create personalized certificates that highlight each employee's unique contributions and accomplishments. Whether it's for outstanding performance, years of service, or completing a special project, our customizable templates and intuitive editing tools make it simple to design certificates that truly stand out.
          <br />
          <br />
          With Maker4U's Employment Certificate Maker, you can elevate your employee recognition efforts and foster a culture of appreciation within your organization. By acknowledging and celebrating the hard work and dedication of your team members, you'll inspire loyalty, motivation, and continued success.
        </>
      ) : (
        <>
          باستخدام أداة إنشاء شهادات التوظيف الخاصة بنا، يمكنك بسهولة إنشاء شهادات مخصصة تسلط الضوء على مساهمات وإنجازات كل موظف الفريدة. سواء كان ذلك للأداء المتميز أو سنوات الخدمة أو إكمال مشروع خاص، فإن نماذجنا القابلة للتخصيص وأدوات التحرير البديهية تجعل من السهل تصميم شهادات تبرز حقًا.
          <br />
          <br />
          باستخدام أداة إنشاء شهادات التوظيف من Maker4U، يمكنك تعزيز جهودك في تقدير الموظفين وتعزيز ثقافة التقدير داخل مؤسستك. من خلال تقدير العمل الجاد والتفاني الذي يبذله أعضاء فريقك والاحتفال بهم، ستلهم الولاء والتحفيز والنجاح المستمر.
        </>
      )}
    </p>
  </div>
</div>


<div className="catlogSection">
  <div>
    <LazyLoadImage src={`${img2}`} />
  </div>
  <div></div>
  <div
    style={{
      textAlign: isLang === 'eng' ? 'left' : 'right',
      direction: isLang === 'eng' ? 'ltr' : 'rtl',
    }}
  >
    <p>{isLang === 'eng' ? 'Design, issue & manage digital certificates in one place' : 'تصميم وإصدار وإدارة الشهادات الرقمية في مكان واحد'}</p>
    <p style={{ fontSize: "16px" }}>
      {isLang === 'eng' ? (
        <>
          Revolutionize your certificate management process with Maker4U's all-in-one solution. Our platform offers a seamless experience for designing, issuing, and managing digital certificates, eliminating the need for multiple tools and systems.
          <br />
          <br />
          With Maker4U, you can easily create stunning certificate designs that align with your brand identity and messaging. Choose from a variety of customizable templates and personalize each certificate with ease. Our intuitive design tools make it simple to add logos, images, and text, ensuring that each certificate reflects the professionalism and quality of your organization.
          <br />
          <br />
          Once your certificates are designed, issuing them is a breeze with Maker4U's automated process. Simply input the recipient's information, and our platform will generate a unique digital certificate that can be instantly delivered via email or downloaded from our secure portal.
          <br />
          <br />
          But the benefits don't stop there. Maker4U also provides robust tools for managing your certificates after they've been issued. Keep track of certificate expiration dates, monitor recipient engagement, and easily update or revoke certificates as needed.
          <br />
          <br />
          By centralizing your certificate management process with Maker4U, you'll save time, reduce administrative overhead, and ensure compliance with industry standards. Say goodbye to manual processes and hello to streamlined certificate management with Maker4U.
        </>
      ) : (
        <>
          احداث ثورة في عملية إدارة الشهادات الخاصة بك باستخدام الحل الشامل من Maker4U. توفر منصتنا تجربة سلسة لتصميم وإصدار وإدارة الشهادات الرقمية، مما يلغي الحاجة إلى أدوات وأنظمة متعددة.
          <br />
          <br />
          مع Maker4U، يمكنك بسهولة إنشاء تصاميم مذهلة للشهادات لكي تتوافق مع هوية علامتك التجارية ورسالتك. اختر من بين مجموعة متنوعة من النماذج القابلة للتخصيص وقم بتخصيص كل شهادة بسهولة. تجعل أدوات التصميم البديهية الخاصة بنا من السهل إضافة الشعارات والصور والنصوص، مما يضمن أن تعكس كل شهادة الاحتراف والجودة في مؤسستك.
          <br />
          <br />
          بمجرد تصميم شهاداتك، يصبح إصدارها أمرًا سهلاً مع عملية Maker4U الآلية. ما عليك سوى إدخال معلومات المستلم، وستقوم منصتنا بإنشاء شهادة رقمية فريدة يمكن تسليمها على الفور عبر البريد الإلكتروني أو تنزيلها من البوابة الآمنة الخاصة بنا.
          <br />
          <br />
          لكن الفوائد لا تتوقف عند هذا الحد. توفر Maker4U أيضًا أدوات قوية لإدارة شهاداتك بعد إصدارها. تتبع تواريخ انتهاء صلاحية الشهادات، وراقب تفاعل المستلم، وقم بتحديث الشهادات أو إلغائها بسهولة حسب الحاجة.
          <br />
          <br />
          من خلال توحيد عملية إدارة الشهادات الخاصة بك مع Maker4U، ستوفر الوقت وتقلل من النفقات الإدارية وتضمن الامتثال لمعايير الصناعة. قل وداعًا للعمليات اليدوية ومرحبًا بإدارة الشهادات المبسطة مع Maker4U.
        </>
      )}
    </p>
  </div>
</div>

<div className="catlogSectionTwo">
  <div>
    <LazyLoadImage src={`${img3}`} />
  </div>
  <div></div>
  <div
    style={{
      textAlign: isLang === 'eng' ? 'left' : 'right',
      direction: isLang === 'eng' ? 'ltr' : 'rtl',
    }}
  >
    <p>
      {isLang === 'eng'
        ? 'The most robust certificate generator for all your certification needs'
        : 'أقوى صانع للشهادات لجميع احتياجاتك من الشهادات'}
    </p>
    <p style={{ fontSize: "16px" }}>
      {isLang === 'eng' ? (
        <>
          Empower your organization with Maker4U's advanced certificate generator, designed to meet all your certification needs. Our robust platform offers unparalleled flexibility and customization options, allowing you to create professional-grade certificates with ease.
          <br />
          <br />
          Say goodbye to manual certificate creation processes and hello to efficiency and reliability with Maker4U's certificate generator. Whether you're issuing certificates for a small team or a large organization, Maker4U has you covered.
        </>
      ) : (
        <>
          قم بتمكين مؤسستك باستخدام صانع الشهادات المتقدم من Maker4U، والذي تم تصميمه لتلبية جميع احتياجاتك المتعلقة بالشهادات. توفر منصتنا القوية مرونة لا مثيل لها وخيارات تخصيص، مما يسمح لك بإنشاء شهادات احترافية بكل سهولة.
          <br />
          <br />
          وداعًا لعمليات إنشاء الشهادات اليدوية ومرحبًا بالكفاءة والموثوقية مع صانع الشهادات من Maker4U. سواء كنت تصدر شهادات لفريق صغير أو منظمة كبيرة، فإن Maker4U سيغطي إحتياجك.
        </>
      )}
    </p>
  </div>
</div>

<div className="catlogSection">
  <div>
    <LazyLoadImage src={`${img2}`} />
  </div>
  <div></div>
  <div
    style={{
      textAlign: isLang === 'eng' ? 'left' : 'right',
      direction: isLang === 'eng' ? 'ltr' : 'rtl',
    }}
  >
    <p>
      {isLang === 'eng'
        ? 'Customizable certificate templates'
        : 'نماذج الشهادات القابلة للتخصيص'}
    </p>
    <p style={{ fontSize: "16px" }}>
      {isLang === 'eng' ? (
        <>
          Design certificates with Maker4U's expansive collection of customizable templates. From elegant to modern, our diverse range of designs caters to every occasion and industry. With our user-friendly platform, you can easily personalize each template to suit your brand and messaging.
          <br />
          <br />
          Whether you're recognizing employee achievements, acknowledging academic accomplishments, or celebrating special events, Maker4U's customizable certificate templates provide the perfect canvas for your creativity. Stand out from the crowd and impress recipients with professionally designed certificates that reflect the excellence of your organization.
        </>
      ) : (
        <>
          تصميم الشهادات باستخدام مكتبة Maker4U الواسعة من النماذج القابلة للتخصيص. من الأناقة إلى الحداثة، تلبي مكتبتنا المتنوعة من التصاميم جميع المناسبات والصناعات. من خلال منصتنا سهلة الاستخدام، يمكنك بسهولة تخصيص كل نموذج ليناسب علامتك التجارية ورسالتك.
          <br />
          <br />
          سواء كنت تعترف بإنجازات الموظفين، أو تشيد بالإنجازات الأكاديمية، أو تحتفل بأحداث خاصة، توفر نماذج الشهادات القابلة للتخصيص من Maker4U اللوحة المثالية لإبداعك. تميز عن الآخرين وأبهر المتلقين بشهادات مصممة بشكل احترافي تعكس تميز مؤسستك.
        </>
      )}
    </p>
  </div>
</div>

<div className="catelogAITexContainer">
  <div
    className="catelogAIText"
    style={{
      textAlign: isLang === 'eng' ? 'left' : 'right',
      direction: isLang === 'eng' ? 'ltr' : 'rtl',
    }}
  >
    <p>{isLang === 'eng' ? 'Experience seamless certificate design with Maker4U' : 'استمتع بتصميم الشهادات السلس مع Maker4U'}</p>
    <p style={{ fontSize: "16px" }}>
      {isLang === 'eng' ? (
        <>
          Elevate your recognition efforts effortlessly with our intuitive platform. Craft professional-grade certificates instantly, no design expertise required. Personalize templates, text, and graphics with ease. Streamline your process and celebrate achievements efficiently with Maker4U's user-friendly design builder.
        </>
      ) : (
        <>
          ارتق بجهود التقدير الخاصة بك بسهولة باستخدام منصتنا البديهية. أنشئ شهادات احترافية على الفور، دون الحاجة إلى خبرة في التصميم. خصص النماذج والنصوص والرسومات بسهولة. قم بتبسيط عمليتك واحتفل بالإنجازات بكفاءة مع أداة إنشاء التصميم البديهية من Maker4U.
        </>
      )}
    </p>
  </div>
</div>

<p className="text-center my-4">
  {isLang === 'eng' ? 'Create certificates in minutes with an intuitive design builder' : 'إنشاء الشهادات في دقائق باستخدام أداة إنشاء التصميم البديهية'}
</p>

<div className="catelogAITexContainer">
  <div
    className="catelogAIText"
    style={{
      textAlign: isLang === 'eng' ? 'left' : 'right',
      direction: isLang === 'eng' ? 'ltr' : 'rtl',
    }}
  >
    <p style={{ fontSize: "16px" }}>
      {isLang === 'eng' ? (
        <>
          Experience the ultimate convenience of designing certificates in minutes with Maker4U's intuitive design builder. Our user-friendly platform empowers you to create professional-grade certificates with ease, even if you're not a design expert.
          <br />
          <br />
          With Maker4U, you can unleash your creativity and personalize every aspect of your certificates. From choosing templates to adding custom text and graphics, our intuitive design builder makes the entire process seamless and straightforward.
          <br />
          <br />
          Say goodbye to time-consuming manual design processes and hello to efficiency and professionalism with Maker4U's intuitive design builder. Whether you're recognizing achievements, awarding certifications, or celebrating milestones, Maker4U has you covered.
        </>
      ) : (
        <>
          استمتع بالراحة القصوى لتصميم الشهادات في دقائق مع أداة إنشاء التصميم البديهية من Maker4U. تتيح لك منصتنا سهلة الاستخدام إنشاء شهادات احترافية بسهولة، حتى إذا لم تكن خبيرًا في التصميم.
          <br />
          <br />
          مع Maker4U، يمكنك إطلاق العنان لإبداعك وتخصيص كل جانب من جوانب شهاداتك. من اختيار النماذج إلى إضافة نص ورسومات مخصصة، تجعل أداة إنشاء التصميم البديهية العملية بأكملها سلسة ومباشرة.
          <br />
          <br />
          قل وداعًا لعمليات التصميم اليدوي التي تستغرق وقتًا طويلاً ومرحبًا بالكفاءة والاحترافية مع أداة إنشاء التصميم البديهية من Maker4U. سواء كنت تشير بالإنجازات أو تمنح الشهادات أو تحتفل بالإنجازات المهمة، فإن Maker4U توفر لك كل ما تحتاجه.
        </>
      )}
    </p>
  </div>
</div>


<div className="cardContainer">
  <div>
    <div>
      <LazyLoadImage src={`${img7}`} />
    </div>
    <div>
      <p>{isLang === 'eng' ? '1. Include Media' : '1. أضف الوسائط'}</p>
      <p style={{ fontSize: "16px" }}>
        {isLang === 'eng'
          ? 'Compile images or movies from stock libraries or computers into the scenario. Add some effects if you like as well.'
          : 'قم بتجميع الصور أو الأفلام من مكتبات الوسائط أو الكمبيوتر في السيناريو. يمكنك إضافة بعض التأثيرات أيضًا إذا كنت ترغب.'}
      </p>
    </div>
  </div>

  <div>
    <div>
      <LazyLoadImage src={`${img8}`} />
    </div>
    <div>
      <p>{isLang === 'eng' ? '2. Personalize' : '2. تخصيص'}</p>
      <p style={{ fontSize: "16px" }}>
        {isLang === 'eng'
          ? 'For more customization, add narration, music, and text to your advertisement. Choose different styling fonts and bright colors.'
          : 'للمزيد من التخصيص، أضف سردًا صوتيًا، موسيقى، ونصًا إلى إعلانك. اختر خطوطًا أنيقة وألوانًا زاهية.'}
      </p>
    </div>
  </div>

  <div>
    <div>
      <LazyLoadImage src={`${img9}`} />
    </div>
    <div>
      <p>{isLang === 'eng' ? '3. Export' : '3. التصدير'}</p>
      <p style={{ fontSize: "16px" }}>
        {isLang === 'eng'
          ? 'You may share your promotional media on the internet or download it in different resolutions and ratios by clicking the download option and exporting it to your computer or sharing it on any platform.'
          : 'يمكنك مشاركة الوسائط الترويجية الخاصة بك على الإنترنت أو تحميلها بتنسيقات ونسب أبعاد مختلفة عن طريق النقر على خيار التنزيل وتصديرها إلى جهاز الكمبيوتر الخاص بك أو مشاركتها على أي منصة.'}
      </p>
    </div>
  </div>
</div>

      <Footer />
    </>
  );
};

export default Catelog;
